import { ITokenizeCard } from './types';

export const tokenizeCard: ITokenizeCard = () => Promise.resolve(null);
